import React from 'react'
import { regionalPagesProps } from 'regions/runtime-components/pages-props'

import { ListItemPageLink } from '../list-item-page-link'

import styles from './style.module.scss'

export const RegionalLinks = () => {
	return (
		<ul>
			{Object.entries(regionalPagesProps).map(([path, pageProps]) => {
				return (
					<ListItemPageLink key={path} path={path} title={pageProps.headProps.title} isRegional />
				)
			})}
		</ul>
	)
}
